import DevicesForm from './DevicesForm';

export default DevicesForm;
